import { z } from 'zod'

export const ModuleEnum = z.enum([
  'FOOD',
  'BATHROOM',
  'MEDICINES',
  'LIQUIDS',
  'PHOTO',
  'BELONGINGS',
  'SLEEP',
  'LESION',
  'CAA'
])

export const ConfigModule = z.array(
  z.object({
    id: z.string(),
    module: ModuleEnum,
    observation: z.string().nullish()
  })
)
export type ConfigModule = z.infer<typeof ConfigModule>
export type ModuleEnum = z.infer<typeof ModuleEnum>
